import axios from 'axios';
import { apiUrl, execUrl } from 'libs/commonVar';
import * as common from 'libs/commonFunc';
import * as commonVar from 'libs/commonVar';

export const postLoginAPI = params => common.requestRaw(apiUrl + 'Login', params, 'post');
export const postLoginGSAPI = params => common.requestRaw(apiUrl + 'LoginGS', params, 'post');
export const getCheckLoginAPI = params => common.requestRaw(apiUrl + 'Login/CheckLogin', params, 'get');
export const reSendRegisterEmail = params => common.requestRaw(apiUrl + 'Register/ReSendRegisterEmail', params, 'post');



// WEBPACK FOOTER //
// ./src/script/libs/loginLib.js